module.exports = __webpack_public_path__ + "static/img/guangzhou1.cd03209.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/guangzhou1.jpg
// module id = oru5
// module chunks = 1